/**
 * Registers the Alpine `$store.drawer` used by the filter sidebar markup
 * (`@click="$store.drawer.DrawerOpen()"` / `DrawerClose()`).
 *
 * Toggles `body.filters-drawer-open` and `html.overflow-hidden`, which the CSS
 * uses to slide the sidebar in and lock page scroll.
 */
const registerDrawerStore = () => {
  if (!window.Alpine || typeof window.Alpine.store !== 'function') return false;

  window.Alpine.store('drawer', {
    open: false,
    DrawerOpen() {
      this.open = true;
      document.body.classList.add('filters-drawer-open');
      document.documentElement.classList.add('overflow-hidden');
    },
    DrawerClose() {
      this.open = false;
      document.body.classList.remove('filters-drawer-open');
      document.documentElement.classList.remove('overflow-hidden');
    },
  });
  return true;
};

document.addEventListener('alpine:init', registerDrawerStore);

if (!registerDrawerStore()) {
  const retry = setInterval(() => {
    if (registerDrawerStore()) clearInterval(retry);
  }, 50);
  setTimeout(() => clearInterval(retry), 5000);
}
